<template>
  <div class="info">
    <p>※</p>
    <p>이미지를 클릭 하시면 더 크게 보실 수 있습니다.</p>
  </div>
</template>

<script>
export default {
  name: "Info",
};
</script>

<style lang="scss" scoped>
@import "@/assets/utils/scss/fluid-typo.scss";
.info {
  position: -webkit-sticky;
  position: sticky;
  top: 0px;
  display: flex;
  justify-content: center;
  align-items: center;
  text-align: center;
  padding: 15px 0;
  font-weight: bold;
  background: #f2ecec;
  color: #666261;
  @include fluid-type(320px, 1600px, 12px, 24px);
  p {
    margin: 0;
    &:first-of-type {
      margin-top: -3px;
    }
  }
}
</style>
